export default __webpack_public_path__ + "locales/ar-SA/SingleSignOn.json?hash=925088551974b8a390c0b01d4b8dc292";